import Fuse from 'fuse.js';
const symbolSearchKeys = [
    { name: 'type', weight: 0.9 },
    { name: 'label', weight: 0.8 },
    { name: 'description', weight: 0.5 },
];
/**
 * Default options for Fuse (https://fusejs.io/api/options.html)
 *
 *    isCaseSensitive: false
 *    includeScore: false
 *    shouldSort: true
 *    includeMatches: false
 *    findAllMatches: false
 *    minMatchCharLength: 1
 *    location: 0
 *    threshold: 0.6
 *    distance: 100
 *    useExtendedSearch: false
 *    ignoreLocation: false
 *    ignoreFieldNorm: false
 *    fieldNormWeight: 1
 *
 *  Matches (fuzzy or exact) - takes into account the 'distance' the pattern is from expected 'location' within the 'threshold'
 *  Fuzzy Search - uses Bitap algorithm for fuzziness scoring
 *  Extended Search - if enabled it allows 'advanced searching' in the pattern (ie, 'client | prospect')
 *  Logical Query Operators - serach function will also take a fuse.Expression instead of string pattern
 */
const symbolSearchOptions = {
    minMatchCharLength: 2,
    threshold: 0.4,
    useExtendedSearch: true,
    keys: symbolSearchKeys,
};
const createSearchExpression = (symbolType, enforceStrictType, pattern) => {
    // match on type of symbol can be exact or fuzzy (fuzzy match useful for searching expressions)
    const typeMatch = enforceStrictType
        ? { type: ('=' + symbolType) }
        : { type: symbolType };
    if (!!pattern) {
        return {
            $and: [typeMatch, { $or: [{ label: pattern }, { description: pattern }] }],
        };
    }
    return typeMatch;
};
export const searchSymbols = (symbols, type, enforceStrictType, line, pattern) => {
    const fuse = new Fuse(symbols, symbolSearchOptions);
    const searchExpression = createSearchExpression(type, enforceStrictType, pattern);
    const searchMatches = fuse.search(searchExpression);
    return searchMatches
        .map(match => match.item)
        .filter(sym => (!!line ? sym.lineNumber < line : true));
};
//# sourceMappingURL=search.js.map